'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _util = require('../../../util');

var _util2 = _interopRequireDefault(_util);

var _icon = require('../../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _trigger = require('../../../trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _lodashCompat = require('lodash-compat');

var _customFilter = require('./custom-filter');

var _customFilter2 = _interopRequireDefault(_customFilter);

var _popover = require('./popover');

var _popover2 = _interopRequireDefault(_popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 设置按钮组
 */

var Setting = function (_M$BaseComponent$Mixi) {
  _inherits(Setting, _M$BaseComponent$Mixi);

  function Setting() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Setting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Setting)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.defaultIcons = {
      'heading': HeadingIcon,
      'more': MoreIcon
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Setting, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var baseCls = _props.className;
      var model = _props.model;

      if (model == null) return null;
      var listItems = [];
      // 如果设置组超过三个，则后面的需要合并显示省略号
      if (model.length > 3) {
        for (var i = 0; i < 2; i++) {
          listItems.push(_react2.default.createElement(
            'li',
            { key: i, className: baseCls + '__item' },
            this.renderIcon(model[i])
          ));
        }
        listItems.push(_react2.default.createElement(
          'li',
          { key: 'more', className: baseCls + '__item' },
          this.renderIcon({
            code: 'more',
            label: '更多',
            icon: 'ellipsis',
            subIcons: model.slice(2).map(function (item) {
              return _this2.renderIcon(item);
            })
          })
        ));
      } else {
        listItems = model.map(function (m, i) {
          return _react2.default.createElement(
            'li',
            { key: i, className: baseCls + '__item' },
            _this2.renderIcon(m)
          );
        });
      }
      return _react2.default.createElement(
        'div',
        { className: this.classNames() },
        _react2.default.createElement(
          'ul',
          { className: baseCls + '__list' },
          listItems
        )
      );
    }
  }, {
    key: 'action',
    value: function action(columns, model) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return new Promise(function ($return, $error) {
        var action = model.action;
        if (action == null) return $return(null);
        return Promise.resolve(action.apply(undefined, [this, columns, model].concat(args))).then(function ($await_1) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(model) {
      var baseCls = this.props.className;
      var code = model.code;
      var icon = model.icon;
      var action = model.action;
      var Component = model.Component;
      var label = model.label;

      //如果没有传入action和Component并且是defaultAction，则渲染相应的

      if (!action && !Component && this.defaultIcons[code]) {
        var _Component = this.defaultIcons[code];
        return _react2.default.createElement(_Component, { model: model, className: baseCls + '__icon' });
      }

      if (Component) {
        return _react2.default.isValidElement(Component) ? Component : _react2.default.createElement(Component, null);
      } else {
        var records = this.context.records;

        var props = {
          onClick: this.action.bind(this, records._getColumns(), model)
        };
        return (0, _lodashCompat.isString)(icon) ? _react2.default.createElement(_icon2.default, { className: baseCls + '__icon', type: icon, domProps: props }) : _react2.default.isValidElement(icon) ? icon : label;
      }
    }
  }]);

  return Setting;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')));

var MoreIcon = function (_M$BaseComponent$Mixi2) {
  _inherits(MoreIcon, _M$BaseComponent$Mixi2);

  function MoreIcon(props) {
    _classCallCheck(this, MoreIcon);

    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(MoreIcon).call(this, props));

    Object.assign(_this3.state, {
      showPopover: false
    });
    return _this3;
  }

  _createClass(MoreIcon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      this.windowEventListener('click', function (e) {
        var showPopover = _this4.state.showPopover;
        var _refs = _this4.refs;
        var container = _refs.container;
        var trigger = _refs.trigger;

        var triggerNode = trigger.getPopupDOMNode();
        if (showPopover && !(0, _reactDom.findDOMNode)(container).contains(e.target) && !triggerNode.contains(e.target)) {
          _this4._togglePopover(false);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var model = this.props.model;
      var icon = model.icon;
      var label = model.label;
      var showPopover = this.state.showPopover;

      var props = {
        onClick: this._togglePopover.bind(this, !showPopover)
      };
      return _react2.default.createElement(
        'div',
        { ref: 'container', className: this.classNames('more-icon') },
        (0, _lodashCompat.isString)(icon) ? _react2.default.createElement(_icon2.default, { className: 'more-icon__icon', type: icon,
          domProps: props }) : _react2.default.isValidElement(icon) ? icon : label,
        showPopover && _react2.default.createElement('span', { className: 'more-icon__pseudo-arrow' }),
        _react2.default.createElement(
          _trigger2.default,
          {
            ref: 'trigger',
            className: 'more-icon__trigger',
            align: this._getAlign(),
            equalTargetWidth: false,
            visible: showPopover,
            target: this._getTarget,
            getPopupContainer: this._getPopupContainer },
          _react2.default.createElement(
            _popover2.default,
            { className: 'more-icon__popover' },
            _react2.default.createElement(
              'ul',
              { className: 'more-icon__icon-list' },
              model.subIcons.map(function (item, i) {
                return _react2.default.createElement(
                  'li',
                  { key: i, className: 'more-icon__icon-item' },
                  item
                );
              })
            )
          )
        )
      );
    }
  }, {
    key: '_getAlign',
    value: function _getAlign() {
      return {
        points: ['tr', 'br'],
        overflow: {
          adjustX: true
        }
      };
    }
  }, {
    key: '_getTarget',
    value: function _getTarget() {
      var target = (0, _reactDom.findDOMNode)(this).parentNode.parentNode;
      return target;
    }
  }, {
    key: '_getPopupContainer',
    value: function _getPopupContainer() {
      return (0, _reactDom.findDOMNode)(this.context.records);
    }
  }, {
    key: '_togglePopover',
    value: function _togglePopover(show) {
      this.setState({ showPopover: show });
    }
  }]);

  return MoreIcon;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')));

var HeadingIcon = function (_M$BaseComponent$Mixi3) {
  _inherits(HeadingIcon, _M$BaseComponent$Mixi3);

  function HeadingIcon(props) {
    _classCallCheck(this, HeadingIcon);

    var _this5 = _possibleConstructorReturn(this, Object.getPrototypeOf(HeadingIcon).call(this, props));

    Object.assign(_this5.state, {
      showPopover: false,
      data: [],
      fixHeader: false
    });
    return _this5;
  }

  _createClass(HeadingIcon, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var records = this.context.records;

      var scroll = records._getScroll();
      var fixHeader = this.state.fixHeader;
      //如果存在，则表头固定为true

      if (scroll.y) {
        fixHeader = true;
      }
      this.setState({ fixHeader: fixHeader });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this6 = this;

      this.windowEventListener('click', function (e) {
        var showPopover = _this6.state.showPopover;
        var _refs2 = _this6.refs;
        var container = _refs2.container;
        var trigger = _refs2.trigger;

        var triggerNode = trigger.getPopupDOMNode();
        if (showPopover && !(0, _reactDom.findDOMNode)(container).contains(e.target) && !triggerNode.contains(e.target)) {
          _this6._togglePopover(false);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var model = this.props.model;
      var icon = model.icon;
      var label = model.label;
      var _state = this.state;
      var showPopover = _state.showPopover;
      var data = _state.data;
      var fixHeader = _state.fixHeader;

      var props = {
        onClick: this._togglePopover.bind(this, !showPopover)
      };
      return _react2.default.createElement(
        'div',
        { ref: 'container', className: this.classNames('heading-icon') },
        (0, _lodashCompat.isString)(icon) ? _react2.default.createElement(_icon2.default, { className: 'heading-icon__icon', type: icon,
          domProps: props }) : _react2.default.isValidElement(icon) ? icon : label,
        showPopover && _react2.default.createElement('span', { className: 'heading-icon__pseudo-arrow' }),
        _react2.default.createElement(
          _trigger2.default,
          {
            ref: 'trigger',
            className: 'heading-icon__trigger',
            align: this._getAlign(),
            equalTargetWidth: false,
            visible: showPopover,
            target: this._getTarget,
            getPopupContainer: this._getPopupContainer },
          _react2.default.createElement(
            _popover2.default,
            { className: 'heading-icon__popover' },
            _react2.default.createElement(_customFilter2.default, { data: data,
              custom: _react2.default.createElement(
                'div',
                { className: 'heading-icon__fix-header' },
                _react2.default.createElement(_icon2.default, { className: _util2.default.classNames("heading-icon__fix-header-icon", {
                    active: fixHeader
                  }), type: 'drawing-pin',
                  domProps: {
                    onClick: this._toggleFixHead.bind(this, !fixHeader)
                  } }),
                _react2.default.createElement(
                  _popover2.default,
                  { className: 'heading-icon__fix-header-popover',
                    placement: 'top' },
                  fixHeader ? '取消固定表头' : '固定表头'
                )
              ),
              onConfirm: this._onFilterChange,
              onCancel: this._togglePopover.bind(this, false) })
          )
        )
      );
    }
  }, {
    key: '_getAlign',
    value: function _getAlign() {
      return {
        points: ['tr', 'br'],
        overflow: {
          adjustX: true
        }
      };
    }
  }, {
    key: '_getTarget',
    value: function _getTarget() {
      var target = (0, _reactDom.findDOMNode)(this).parentNode.parentNode;
      return target;
    }
  }, {
    key: '_getPopupContainer',
    value: function _getPopupContainer() {
      return (0, _reactDom.findDOMNode)(this.context.records);
    }
  }, {
    key: '_togglePopover',
    value: function _togglePopover(show) {
      var records = this.context.records;

      var columns = records._getColumns();
      var data = columns.map(function (c) {
        return (0, _lodashCompat.pick)(c, ['code', 'label', 'show']);
      });

      this.setState({
        showPopover: show,
        data: data
      });
    }
  }, {
    key: '_onFilterChange',
    value: function _onFilterChange(columns) {
      var _this7 = this;

      var fixHeader = this.state.fixHeader;
      var records = this.context.records;

      var dataColumns = records._getColumns();
      var columnsMap = {};
      dataColumns.forEach(function (c) {
        columnsMap[c.code] = c;
      });
      dataColumns = columns.map(function (c) {
        return Object.assign(columnsMap[c.code], c);
      });

      records._setColumns(dataColumns, function () {
        var records = _this7.context.records;

        records._onColumnsFilter(columns.filter(function (f) {
          return f.show;
        }).map(function (f) {
          return f.code;
        }), columns);
      });

      var scroll = records._getScroll();
      if (fixHeader && !scroll.y) {
        scroll.y = true;
      } else if (!fixHeader && scroll.y) {
        scroll.y = false;
      }
      records._setScroll(scroll);
      this._togglePopover(false);
    }
  }, {
    key: '_toggleFixHead',
    value: function _toggleFixHead(on) {
      this.setState({
        fixHeader: on
      });
    }
  }]);

  return HeadingIcon;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')));

exports.default = Setting;